var map = {
	"./ic-deals-active.svg": "6e58",
	"./ic-departments-active.svg": "2ed0",
	"./ic-favorites-active.svg": "5660",
	"./ic-featured-active.svg": "1031",
	"./ic-home-active.svg": "ecf5",
	"./ic-menu-active.svg": "9ddf",
	"./ic-popular-active.svg": "ab9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c49";